import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { GeneralStateValues, updateKey } from './slice';

export const fields: IBaseField<keyof GeneralStateValues>[] = [
  {
    name: 'iHaveOwnershipInANonUsCorporationOrPartnership',
    label: 'I have ownership in a non-US corporation or partnership',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'iHaveAUsCorporationOrPartnership',
    label: 'I have a US Corporation or Partnership',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'iHaveANonUsTrust',
    label: 'I have a Non-US Trust',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'iHaveAUsTrust',
    label: 'I have a US Trust',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
];

export const validationSchema = Yup.object().shape({});
